<template>
  <div>
    <div class="top-box">
      <span class="back-btn" @click="back">
        <i class="el-icon-back" />
        群体趋势
      </span>
    </div>
    <div class="flex">
      <div class="groupStatistics-left">
        <div v-for="(v, index) in tabList" :key="index">
          <div class="tit flex items-c">
            <img
              src="https://oss.zhihanyun.com/1729499659568_assess-icon.png"
              class="icon"
            >
            {{ v.title }}
          </div>
          <ul>
            <li
              v-for="(q, qIndex) in v.children"
              :key="qIndex"
              :class="{'li-in': $route.path.indexOf(q.type) !== -1}"
              @click="go(q)"
            >
              {{ q.title }}
            </li>
          </ul>
        </div>
      </div>
      <div class="groupStatistics-right">
        <router-view />
      </div>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      tabList: [
        {
          title: '体格发育',
          children: [
            // {
            //   title: '身高分布',
            //   type: 'height'
            // },
            {
              title: 'BMI分布',
              type: 'bmi'
            }
          ]
        },
        {
          title: '体能发育',
          children: [
            {
              title: '综合能力均分',
              type: 'avg'
            },
            {
              title: '综合能力占比',
              type: 'distribution'
            }
          ]
        }
      ]
    }
  },
  methods: {
    go(q) {
      let params = JSON.parse(this.$route.query.searchParams)
      this.$router.push({
        path: `/trendStatistics/${q.type}?searchParams=${encodeURIComponent(
          JSON.stringify(params)
        )}`
      })
    },
    back() {
      let params = JSON.parse(this.$route.query.searchParams)
      this.$router.push({
        path: `/teachingProtection/assessment/assessment/main?searchParams=${encodeURIComponent(
          JSON.stringify(params)
        )}`
      })
    }
  }
}
</script>
<style scoped lang="scss">
.top-box {
  height: 60px;
  background: #ffffff;
  border-bottom: 1px solid #f0f0f0;
  font-weight: 600;
  font-size: 18px;
  color: #333333;
  line-height: 60px;
  padding-left: 30px;
  .back-btn {
    cursor: pointer;
  }
}
.groupStatistics-left {
  width: 180px;
  min-height: calc(100vh - 70px);
  background: #ffffff;
  padding: 20px 20px;
  margin-right: 20px;
  box-sizing: border-box;
  .icon {
    height: 14px;
    width: 14px;
    margin-right: 10px;
  }
  .tit {
    font-weight: bold;
    line-height: 40px;
    height: 40px;
  }
  ul {
    li {
      height: 36px;
      border-radius: 4px;
      line-height: 36px;
      cursor: pointer;
      padding-left: 24px;
      &:hover {
        background: linear-gradient(90deg, #fff0eb 0%, #fffaf8 100%);
        border-radius: 4px;
        color: #ff7146;
      }
    }
    .li-in {
      background: linear-gradient(90deg, #fff0eb 0%, #fffaf8 100%);
      border-radius: 4px;
      color: #ff7146;
    }
  }
}
.groupStatistics-right {
  width: calc(100% - 200px);
}
</style>
